












import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DragLiModel } from "./models";

@Component
export default class UiDragLiComponent extends Vue {
  @Prop() data: DragLiModel;

  created() {}

  mounted() {}
}
